import { render, staticRenderFns } from "./Code.vue?vue&type=template&id=076e061d&scoped=true"
import script from "./Code.vue?vue&type=script&lang=js"
export * from "./Code.vue?vue&type=script&lang=js"
import style0 from "./Code.vue?vue&type=style&index=0&id=076e061d&prod&scoped=true&lang=css"
import style1 from "./Code.vue?vue&type=style&index=1&id=076e061d&prod&lang=css"
import style2 from "./Code.vue?vue&type=style&index=2&id=076e061d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "076e061d",
  null
  
)

export default component.exports